// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pEqyn","notification":"styles_notification__3Zxi+"};